import axios from "axios";
import { api } from "./api_route";

export const empanelmentOTPValidation = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/OTPValidation`, values);

    // return result;
    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};

export const empanelmentRegister = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/registration`, values);

    // return result;
    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};



export const empanelmentEmailOTPValidation = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/emailOTPValidation`, values);

    // return result;
    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};


export const empanelmentOptions = async (values) => {
  try {
    const result = await axios.get(`${api}/empanelment/options`);

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};

export const empanelmentProfessionalRegistration = async (values) => {
  try {
    const result = await axios.post(
      `${api}/empanelment/professionalRegistration`,
      values
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};
export const empanelmentPersonalDetails = async (values) => {
  try {
    const result = await axios.post(
      `${api}/empanelment/empanelmentPersonalDetails`,
      values
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};

export const empanelmentRegisterDetails = async (values) => {
  try {
    const result = await axios.post(
      `${api}/empanelment/registerDetails`,
      values
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};

export const empanelmentLogin = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/registerLogin`, values);

    return result;
  } catch (error) {
    return [];
  }
};

export const empanelmentFetchDocument = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/fetchDocument`, values);

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};

export const empanelmentRegisterAccess = async (values) => {
  try {
    const result = await axios.get(`${api}/empanelment/register`);

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};


export const empanelmentProfessionalDetails = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/professionalDetails`,values);

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};

export const reviewAndConfirmation = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/reviewAndConfirmation`,values);

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};


export const emailCheck = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/emailCheck`,values);

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};

export const mobileCheck = async (values) => {
  try {
    const result = await axios.post(`${api}/empanelment/mobileCheck`,values);

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};
